import { DEFAULT_STATS } from '../../../../core/constants';

export type DeliveryHistoryRequest = {
    fromDate?: string;
    toDate?: string;
};

export type DeliveryHistoryResponse = {
    suppId?: string;
    riderId?: string;
    fromDate?: string;
    toDate?: string;
    totFinishCnt?: number;
    totRejectCnt?: number;
    totAssingCancelCnt?: number;
    totDeliCancelCnt?: number;
    totMorTimeCnt?: number;
    totAfterNonCnt?: number;
    totNightNonCnt?: number;
    totNightCnt?: number;
    totDeliveryAmt?: number;
    totFinishFoodCnt?: number;
    totFinishBmartCnt?: number;
    totFinishStoreCnt?: number;
    totHourCounts?: number[];
    success?: boolean;
    message?: string;
};

/**
 * 배달 이력 통계 엔티티
 */
export type DeliveryHistoryStats = {
    completedCount: number;
    rejectedCount: number;
    acceptanceRate: number;
    deliveryFee: number;
    morningLunchPeakCount: number;
    afternoonNonPeakCount: number;
    eveningPeakCount: number;
    nightPeakCount: number;
    foodCount: number;
    bmartCount: number;
    storeCount: number;
    hourCounts: number[];
};

export const DEFAULT_DELIVERY_HISTORY_STATS: DeliveryHistoryStats = {
    ...DEFAULT_STATS,
    foodCount: 0,
    bmartCount: 0,
    storeCount: 0,
    hourCounts: new Array(24).fill(0),
};
